module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position3.fe54b5df.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position3.png
// module id = 3097
// module chunks = 11